export const TITLES = {
    REPETITIVE_SPOT: "Repetitive Spot - Are you Sure?",
    EMPTY_SPOT: 'Empty Spot - Are you Sure?'
}